import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "./styles/globals.css";
import "@/lib/i18n";

import { FeaturebaseProvider } from "featurebase-js/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { capturePlanIntent } from "@/lib/billing/plan-intent";
import { App } from "./app";

// Avant le routeur : ses redirections (connexion, onboarding) effaceraient le
// plan choisi sur la page Tarifs du site.
capturePlanIntent();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <FeaturebaseProvider
      appId="6ab1b1f1cae3580f4b1b4fa8"
      hideDefaultLauncher
      alignment="left"
    >
      <App />
    </FeaturebaseProvider>
  </StrictMode>,
);
